<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<div class="grid align-items-end vertical-container fluid ">
  <div class="col-4">
    <h5>В новом документе ({{count}})</h5>
    <p-selectButton [options]="actions" [(ngModel)]="selectedActions" multiple="true" optionLabel="name" optionValue="value" (onChange)="onDocTypeChanges($event)"></p-selectButton>
  </div>

  <div class="col-2" *ngIf="itIsSpecification">
    <p-dropdown [options]="warrantyOptionsList" [(ngModel)]="warranty" class=""
                editable="true" pTooltip="Гарантия (срок, условия)" tooltipPosition="top"></p-dropdown>
  </div>

  <div class="col-2">
    <p-button label="Очистить" icon="pi pi-trash" (onClick)="onClearRows($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="false"
              pTooltip="Очистить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>
  <div class="col-2">
    <p-button label="Сначала" icon="pi pi-undo" (onClick)="onRefreshRows($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="false"
              pTooltip="Обновить содержимое нового документа" tooltipPosition="top"></p-button>
  </div>

  <div class="grid fluid col-12" *ngIf="thereIsManufacturedItems">
    <div class="col-12">
      <p-fieldset legend="Сборные изделия {{insertMode}}">
        <div class="col-12">
          <p-radioButton name="groupname" value="m1" [(ngModel)]="insertMode" (onClick)="onInsertModeSelect($event)" label="Не вставлять сборные изделия"></p-radioButton>
        </div>
        <div class="col-12">
          <p-radioButton name="groupname" value="m2" [(ngModel)]="insertMode" (onClick)="onInsertModeSelect($event)" label="Вставить сборные изделия как целое"></p-radioButton>
        </div>
        <div class="col-12">
          <p-radioButton name="groupname" value="m3" [(ngModel)]="insertMode" (onClick)="onInsertModeSelect($event)" label="Создать отдельные документы для каждого сборного изделия с развернутым составом"></p-radioButton>
        </div>
        <div class="col-12">
          <p-radioButton name="groupname" value="m4" [(ngModel)]="insertMode" (onClick)="onInsertModeSelect($event)" label="Создать отдельный документ для выбранного сборного изделия с развернутым составом"></p-radioButton>
        </div>
        <div class="col-12">
          <p-dropdown [options]="products" [dataKey]="prodid" [(ngModel)]="selectedManufacturedItem" optionLabel="prodname" optionValue="prodid"
                      class="p-button-help" [disabled]="(insertMode != 'm4')" 
                      (onChange)="onSelectedItemChange($event)" placeholder="Выбрать товар..."
                      filter="true" filterPlaceholder="Найти по коду..."
                      pTooltip="Товары в документе {{serialProdId}}" tooltipPosition="top"></p-dropdown>
        </div>
      </p-fieldset>
    </div>
  </div>
</div>
